import { getHomeFeed } from "@api/tracklists";
import { useContext } from "solid-js";
import { produce } from "solid-js/store";
import { playerContext } from "../..";
import type { PlayerTrack } from "../../types";

const useContinue = () => {
	const { player, setPlayer } = useContext(playerContext);

	const handlePreloadHome = (page: number) => {
		getHomeFeed(page).then((res) => {
			if (!res.length) {
				setPlayer("feed", "type", "HOME");
				return handlePreloadHome(1);
			}

			setPlayer(
				produce((pl) => {
					pl.queue = pl.queue.concat(
						res.flatMap((tr) =>
							tr.tracks.map<PlayerTrack>((t, index) => ({
								id: t.id,
								index,
								name: t.name,
								platform: t.platform,
								type: "TRACK",
								tracklistUuid: tr.uuid,
								track: t,
								author: t.author.nickname,
								length: t.length,
								photo: t.photo,
							})),
						),
					);
					if (pl.feed.type === "HOME") pl.feed.page = page;
				}),
			);
		});
	};

	return () => {
		const track = player.queue[player.track + 1];
		if (track) return;

		switch (player.feed.type) {
			case "HOME":
				handlePreloadHome(player.feed.page + 1);
				break;
		}
	};
};
export default useContinue;
